import React from "react";
import ReactTable from "react-table";
import Pagination from "../../../components/DatatablePagination";
import { GetSelectTime } from "../../../helpers/SelectTime";
import moment from "moment";
import { AddCommaNumber } from "../../../helpers/Utils";

import { injectIntl } from "react-intl";

const ContentMultiForm = (props) => {
  const { data, intl } = props;
  // console.log('props: ', props);
  const columns = [
    {
      Header: intl.formatMessage({ id: "treasury.header.name" }),
      accessor: "name",
      minWidth: 150,
      Cell: (props) => <span className="text-capitalize">{props.value}</span>,
    },
    {
      Header: intl.formatMessage({ id: "treasury.header.value" }),
      accessor: "value",
      Cell: (props) => AddCommaNumber(props.value),
    },
    {
      Header: intl.formatMessage({ id: "treasury.header.note" }),
      accessor: "note",
    },
    {
      Header: intl.formatMessage({ id: "treasury.header.statistic" }),
      accessor: "time",
      Cell: (props) => GetSelectTime(props.value).label,
    },
    {
      Header: intl.formatMessage({ id: "treasury.header.creator" }),
      accessor: "user_created_id",
    },
    {
      Header: intl.formatMessage({ id: "treasury.header.created_at" }),
      accessor: "createdAt",
      Cell: (props) => moment(props.value).format("DD/MM/YYYY"),
    },
  ];
  return (
    <ReactTable
      defaultPageSize={20}
      data={data}
      columns={columns}
      minRows={0}
      showPageJump={false}
      showPageSizeOptions={true}
      PaginationComponent={Pagination}
      NoDataComponent={() => null}
    />
  );
};

export default injectIntl(ContentMultiForm);
